import { render, staticRenderFns } from "./JtFormCard.vue?vue&type=template&id=42ba5900&scoped=true"
import script from "./JtFormCard.vue?vue&type=script&lang=js"
export * from "./JtFormCard.vue?vue&type=script&lang=js"
import style0 from "./JtFormCard.vue?vue&type=style&index=0&id=42ba5900&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ba5900",
  null
  
)

export default component.exports